import Axios from 'configs/Axios';
import { CubicleFormValues, CubicleResponseData } from 'types/cubicles';

export const getAllCubicles = () => Axios.get<CubicleResponseData>('/cubicle');

export const addNewCubicle = (data: CubicleFormValues) =>
  Axios.post('/cubicle', data);

// PUT /cubicle replaces all the cubicle data that is not passed
// pass all the cubicle data, not only that you want to change
export const updateCubicle = (data: CubicleFormValues) =>
  Axios.put('/cubicle', data);

export const deleteCubicle = (cubicleId: string) =>
  Axios.delete(`/cubicle/${cubicleId}`);
